/*
 * student-header messages
 *
 * This contains all the text for the student-header component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    noResultFound: {
        id: 'empty-state.components.noResultFound',
        defaultMessage: 'No results found'
    }
});



// WEBPACK FOOTER //
// ./app/components/empty-state/messages.js